<template>
  <div>

    <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
      <span class="alert-danger">У вас нет доступа к этой странице.</span>
    </div>


    <div class="main-content bg-white" v-if="$currentUser.role != 'account'">
      <div class="page-header">
        <h3 class="page-title">Курсы валют</h3>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div v-if="!isMobile">
            <b-table v-for="(rate, index) in rates" :key="index" hover responsive bordered
                     small
                     thead-class="hidden_header"
                     :fixed="true"
                     :items="rate.currencies"
                     :fields="fields"
                     no-local-sorting>

              <template #thead-top="data">
                <b-tr>
                  <b-th colspan="3">
                    <span style="display: inline-block; width: 120px">
                      {{ parsePeriod(rate.period) }}
                    </span>
                    <b-button v-if="$currentUser.role === 'admin'" size="sm" class="btn btn-warning"
                              @click.stop="edit(rate)">
                      <i class="icon-fa icon-fa-edit"></i>
                    </b-button>
                  </b-th>
                </b-tr>
              </template>

              <template v-slot:cell(currency)="row">
                <span v-if="row">{{ row.item.currency + ' -> USD' }}</span>
              </template>

              <template v-slot:cell(rate)="row">
                <span v-if="row">{{ row.item.rate  + ' (' + row.item.usdRate + ')'}}</span>
              </template>

              <template v-slot:cell(type)="row">
                <span v-if="row.item.type === 'auto'">Автоматический</span>
                <span v-else>Ручной</span>
              </template>

            </b-table>
          </div>

          <div v-if="isMobile">
            <div v-for="(rate, index) in rates" :key="index">
              <div>
                <span style="display: inline-block; width: 120px;">
                      {{ parsePeriod(rate.period) }}
                    </span>
                <b-button v-if="$currentUser.role === 'admin'" size="sm" class="btn btn-warning"
                          @click.stop="edit( rates[index])">
                  <i class="icon-fa icon-fa-edit"></i>
                </b-button>
              </div>
              <b-table hover responsive bordered stacked
                       small
                       :items="rate.currencies"
                       :fields="fields"
                       no-local-sorting>

                <template v-slot:cell(currency)="row">
                  <span v-if="row">{{ row.item.currency + ' -> USD' }}</span>
                </template>

                <template v-slot:cell(rate)="row">
                  <span v-if="row">{{ row.item.rate  + ' (' + row.item.usdRate + ')'}}</span>
                </template>

                <template v-slot:cell(type)="row">
                  <span v-if="row.item.type === 'auto'">Автоматический</span>
                  <span v-else>Ручной</span>
                </template>

              </b-table>
            </div>
          </div>

        </div>
      </div>

      <b-modal ref="editRatesModal"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               id="editRatesModal" size="md"
               :title="'Редактировать курсы ' + parsePeriod(selectedRates.period)" hide-footer>
        <EditRatesModal :rates="selectedRates"></EditRatesModal>
      </b-modal>

    </div>

  </div>
</template>

<script>

import RatesDataService from "../../services/ratesDataService"
import EditRatesModal from "./modals/EditRatesModal";

export default {
  name: 'rates',
  components: {
    EditRatesModal
  },
  data() {
    return {
      pageSize: 50,
      selectedRates: {},
      fields: [
        {
          key: 'currency',
          label: 'Валюта',
        },
        {
          key: 'rate',
          label: 'Курс',
        },
        {
          key: 'type',
          label: 'Тип',
        },
      ],


      rates: [],

      isMobile: false,
      window: {
        width: 0,
        height: 0
      },
      isXl: false,
    }
  },
  methods: {
    edit(row) {
      this.selectedRates = row
      this.$refs.editRatesModal.show()
    },

    getRates() {
      RatesDataService.getRates()
        .then(rates => {
          this.rates = rates
        })
    },

    parsePeriod(date) {
      return (new Date(Date.parse(date))).toLocaleString('default', {
        month: 'long',
        year: 'numeric'
      })
    },

    calculateUsdCurrencyRate(rate)
    {
      return (1/rate).toFixed(4);
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.isMobile = this.window.width < 415;
      this.isXl = this.window.width > 1199;
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },

  mounted() {
    this.getRates()
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>
<style>

.hidden_header tr:last-child {
  display: none;
}

.btn i {
  text-align: center !important;
}

.popover-body {
  max-height: 200px;
  overflow: scroll;
}

.vdp-datepicker input {
  background-color: white !important;
  width: 100% !important;
}

.dateFrom {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.dateTo {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.filterComponent {
  height: 30px !important;
}

.filterComponent .vs__dropdown-toggle {
  height: 30px !important;
}

.filterComponent .input-date {
  height: 30px !important;
}

.filterComponent .dateFrom {
  height: 30px !important;
}

.filterComponent .dateTo {
  height: 30px !important;
}

.input-date {
  border-top-left-radius: 0.2rem !important;
  border-bottom-left-radius: 0.2rem !important;
}

.mainButton {
  width: 100%;
}

.date {
  width: 100%;
}

.datePickerXl {
  min-width: 100% !important;
  max-width: 100% !important;
}

.input-group-append {
  width: 100%;
}

.myOffers {
  padding-top: 4px;
}

.groupComponent .vs__selected {
  margin: 2px 2px 4px 0 !important;
}

.table-sm th {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
  padding-left: 5px;
  width: .2em;
}

@media (max-width: 576px) {
  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }
}

@media (min-width: 768px) {
  .dateLeft .vdp-datepicker__calendar {
    right: 0 !important;
  }

  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }
}

@media (min-width: 1200px) {
  .myOffers {
    max-width: 14.76666667% !important;
  }

  .input-date {
    width: 146px !important;
  }
}

@media (min-width: 1300px) {
  .input-date {
    width: 160px !important;
  }
}

@media (min-width: 1400px) {
  .input-date {
    width: 170px !important;
  }

  .myOffers {
    max-width: 12.66666667% !important;
  }
}

@media (min-width: 1500px) {
  .input-date {
    width: 190px !important;
  }
}

@media (min-width: 1600px) {
  .input-date {
    width: 200px !important;
  }

  .myOffers {
    max-width: 11.46666667% !important;
  }
}

@media (min-width: 1700px) {
  .input-date {
    width: 220px !important;
  }
}

@media (min-width: 1800px) {
  .input-date {
    width: 230px !important;
  }
}

@media (min-width: 1900px) {
  .input-date {
    width: 240px !important;
  }

  .myOffers {
    max-width: 8.66666667% !important;
  }
}

</style>




// WEBPACK FOOTER //
// resources/js/views/front/Rates.vue